type WindowWithAppConfigUrl = Window & {
    APP_CONFIG_URL?: string
}

/**
 * Points app config requests at the origin serving the embedded bundle.
 */
const setAppConfigUrlFromCurrentScript = () => {
    const currentScript = document.currentScript as HTMLScriptElement | null

    if (!currentScript?.src) return

    const scriptUrl = new URL(currentScript.src)

    if (!scriptUrl.pathname.endsWith('/index.js')) return

    const appConfigUrl = new URL('/app.config', scriptUrl).href
    const appWindow = window as WindowWithAppConfigUrl
    appWindow.APP_CONFIG_URL = appConfigUrl
}

export default setAppConfigUrlFromCurrentScript
